
















import { defineComponent, onMounted } from '@vue/composition-api';
import { RightArrowOutline12, WarningOutline16 } from '@hb/coffee-icons';
import { ubtSetupPageButton, ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import jumpToVerifyCredit from '@/shared/verify-credit-controller';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import { TP_IDENTITY_EXPIRES_BAR } from '@/pages/home/tianqi';

export default defineComponent({
  name: 'IdentityExpiresBar',
  components: {
    RightArrowOutline12,
    WarningOutline16,
  },
  setup() {
    const onIdentityExpiresClick = () => {
      ubtSetupPageButton(TP_IDENTITY_EXPIRES_BAR);

      jumpToVerifyCredit(VerifySceneEnum.UPDATE_EXPIRES_IDENTITY);
    };

    onMounted(() => {
      ubtSetupModuleExpose(TP_IDENTITY_EXPIRES_BAR);
    });

    return {
      onIdentityExpiresClick,
    };
  },
});
